declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest, ActorContactInfoRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../services/hcp.service';


import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SaveIvfCycleInseminationLogRequest } from '../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../models/master/mastermodel';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { NgbSearchProviderModal } from './searchprovider.modal';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'ngbaddinseminationlog',
    templateUrl: './addinseminationlog.modal.html',
    styleUrls: ['./addinseminationlog.modal.scss']
})

export class NgbAddInseminationLogModal implements OnInit {
    @ViewChild('f') IdentitiesForm: NgForm;
    @Input() ActorCode;
    @Input() IsShowDetail: boolean = false;
    //@Input() CurrentActorAddEmergencyInfoRequest: EmergencyContactInfoRequest;
    @Input() ServiceCode: number;
    @Input() TreatmentCycleCode: number;
    @Input() Gradingmodel: string;
    @Input() Doctor: number;
    @Input() ProcessedBy: number;
    @Input() Nurse: number;
    //@Input() InseminationTime: string;
    searchTitle: string;
    public ApiResData: ApiResponseModel;

    public isRequesting: boolean = false;
    public ShowService: boolean = true;
    public ProviderName: string;
    public ProviderCode: number;
    public NurseName: string;
    public NurseCode: number;
    public ProvidedName: string;
    public ProvidedCode: number;
    public ProviderNumber: number;
    public Nursenumber: number;
    public ProvidedNumber: number;
    //public NtimesInformed: number;
    public maxDate: NgbDateStruct;
    public minDate: NgbDateStruct;
    public NewDate: NgbDateStruct;
    public Time: NgbDateStruct;
    //public IsSelected: boolean;
    CurrentSaveIvfCycleInseminationLogRequest: SaveIvfCycleInseminationLogRequest;

    constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService, private spinner: NgxSpinnerService,
        private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
        private router: Router, private route: ActivatedRoute, private hcpservice: HCPService,
        private tosterservice: NGXToastrService, private modalService: NgbModal, private parserFormatter: NgbDateParserFormatter) { }
    ngOnInit() {
        this.CurrentSaveIvfCycleInseminationLogRequest = new SaveIvfCycleInseminationLogRequest();

        this.CurrentSaveIvfCycleInseminationLogRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.ShowService = false;


        this.LoadRegistries();


    }




    LoadRegistries() {
        this.StartRefreshing();



        //this.GetBranchMap();


    }

    DoctorSelection() {
        const modalRef = this.modalService.open(NgbSearchProviderModal,
            {
                centered: true,
                size: 'lg',
                backdrop: 'static',
                keyboard: false
            })
        modalRef.componentInstance.IsShowDoctor = true;
        modalRef.componentInstance.DoctorType = 'All';
        modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
            this.ProviderName = receivedEntry.make;
            this.ProviderCode = receivedEntry.value;
            this.ProviderNumber = receivedEntry.number;
            //alert(this.ProviderName);
        })
    }
    NurseSelection() {
        const modalRef = this.modalService.open(NgbSearchProviderModal,
            {
                centered: true,
                size: 'lg',
                backdrop: 'static',
                keyboard: false
            })
        modalRef.componentInstance.IsShowNurse = true;
        modalRef.componentInstance.DoctorType = 'All';
        modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
            this.NurseName = receivedEntry.make;
            this.NurseCode = receivedEntry.value;
            this.Nursenumber = receivedEntry.number;
            //alert(this.NurseName);
        })
    }
    ProvidedSelection() {
        const modalRef = this.modalService.open(NgbSearchProviderModal,
            {
                centered: true,
                size: 'lg',
                backdrop: 'static',
                keyboard: false
            })
        modalRef.componentInstance.IsShowProvieded = true;
        modalRef.componentInstance.DoctorType = 'All';
        modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
            this.ProvidedName = receivedEntry.make;
            this.ProvidedCode = receivedEntry.value;
            this.ProvidedNumber = receivedEntry.number;
            //alert(this.ProvidedName);
        })
    }

    onSubmit() {
        this.spinner.show();
        this.StartRefreshing();
        //alert(this.CurrentActorEmploymentPreferencesRequest.ReasonForAccommodation);
        this.CurrentSaveIvfCycleInseminationLogRequest.ConditionalOperator = 1;
        this.CurrentSaveIvfCycleInseminationLogRequest.InseminationDate = new Date(this.parserFormatter.format(this.NewDate));
        this.CurrentSaveIvfCycleInseminationLogRequest.InseminationTime = new Date(this.parserFormatter.format(this.NewDate));
        //this.CurrentSaveIvfCycleInseminationLogRequest.InseminationTime = this.InseminationTime;
        this.CurrentSaveIvfCycleInseminationLogRequest.DateofCollection = new Date(this.parserFormatter.format(this.NewDate));
        this.CurrentSaveIvfCycleInseminationLogRequest.TimeofCollection = new Date(this.parserFormatter.format(this.NewDate));
        this.CurrentSaveIvfCycleInseminationLogRequest.TreatmentCycleCode = this.TreatmentCycleCode;
        this.CurrentSaveIvfCycleInseminationLogRequest.IterationType = "Pre-Wash";
        //this.CurrentSaveIvfCycleInseminationLogRequest.DoctorName = this.ProviderName;
        //this.CurrentSaveIvfCycleInseminationLogRequest.Doctor = this.Doctor;
        //this.CurrentSaveIvfCycleInseminationLogRequest.ProcessedBy = this.ProcessedBy;
        //this.CurrentSaveIvfCycleInseminationLogRequest.ProcessedByName = this.ProvidedName;
        this.CurrentSaveIvfCycleInseminationLogRequest.InseminationLogCode = 0;
        this.CurrentSaveIvfCycleInseminationLogRequest.Patient = 0;
        this.CurrentSaveIvfCycleInseminationLogRequest.NtimesInformed = 0;
        //alert(this.CurrentSaveIvfCycleInseminationLogRequest.ProcessedByName);
        //this.CurrentSaveIvfCycleInseminationLogRequest.Nurse = this.Nurse;
        //this.CurrentSaveIvfCycleInseminationLogRequest.NurseName = this.NurseName;
        this.CurrentSaveIvfCycleInseminationLogRequest.SlideObserved = true;
        this.actorservice.SaveIvfCycleInseminationLog(this.CurrentSaveIvfCycleInseminationLogRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        this.ShowService = false;
                        //alertFunctions.AlertParam('Saved Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        this.spinner.hide();
                        this.activeModal.close();

                        this.stopRefreshing();
                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");
                        this.activeModal.close();
                        this.spinner.hide();
                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                        this.activeModal.close();


                    }
                    else {
                        this.spinner.hide();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                        this.activeModal.close();
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.activeModal.close();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.activeModal.close();
                        this.stopRefreshing();
                    }
                }
            );

    }

    onAssignedToActorCodeEmbryologist(event: any) {

        if (event != null) {
            //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
            this.CurrentSaveIvfCycleInseminationLogRequest.ProcessedBy = event;
            this.CurrentSaveIvfCycleInseminationLogRequest.ProcessedByName = event;
            // console.log('event--_>' + event);
            //   }
        }

    }

    onAssignedToActorCodeEmbryologist1(event: any) {

        if (event != null) {
            //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
            this.CurrentSaveIvfCycleInseminationLogRequest.Nurse = event;
            this.CurrentSaveIvfCycleInseminationLogRequest.NurseName = event;
            // console.log('event--_>' + event);
            //   }
        }

    }

    onAssignedToActorCodeEmbryologist2(event: any) {

        if (event != null) {
            //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
            this.CurrentSaveIvfCycleInseminationLogRequest.Doctor = event;
            this.CurrentSaveIvfCycleInseminationLogRequest.DoctorName = event;
            // console.log('event--_>' + event);
            //   }
        }

    }


    private stopRefreshing() {
        this.loaderService.displayLoader(false);
        this.isRequesting = false;
    }
    private StartRefreshing() {
        this.loaderService.displayLoader(true);
        this.isRequesting = true;
    }





}
